import { useMemo } from 'react';

import dayjs, { DATETIME_SECONDS_FORMAT } from '@webtrader/core/dayjs';
import { useTranslation } from '@webtrader/core/i18n';
import { useTimezone } from '@webtrader/core/services/company';

const TIMEZONE_DISPLAY_FORMAT_DATE = 'YYYY-MM-DD';

interface IServerTimeProps {
  timestamp: number;
  serverTime: boolean;
  dateOnly?: boolean;
}

export const useMarketTime = (props: IServerTimeProps) => {
  const { t } = useTranslation();
  const { timestamp, serverTime, dateOnly } = props;

  const { configs, loading } = useTimezone();

  const [displayTimeLabel, displayTime] = useMemo(() => {
    if (loading) {
      return ['', ''];
    }

    if (configs && serverTime) {
      const { offset } = configs;

      return [
        t('Server Time'),
        dayjs(timestamp)
          .utcOffset(offset)
          .format(dateOnly ? TIMEZONE_DISPLAY_FORMAT_DATE : DATETIME_SECONDS_FORMAT)
      ];
    }

    return [
      t('Device Time'),
      dayjs(timestamp).format(dateOnly ? TIMEZONE_DISPLAY_FORMAT_DATE : DATETIME_SECONDS_FORMAT)
    ];
  }, [loading, configs, serverTime, t, timestamp, dateOnly]);

  return {
    configs,
    loading,
    displayTimeLabel,
    displayTime
  };
};
